module.exports = __webpack_public_path__ + "static/img/8.1ed0b68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/su/8.jpg
// module id = XfXp
// module chunks = 1